import React from "react";
import "./HeaderControls.css";

const HeaderControls = ({ selectedDate, setSelectedDate, view }) => {
  // Función para manejar el botón "Hoy"
  const handleTodayClick = () => {
    setSelectedDate(new Date()); // Regresa la fecha a hoy
  };

  // Función para manejar las flechas de navegación
  const handleNavigate = (direction) => {
    const newDate = new Date(selectedDate);
    if (view === "day") {
      newDate.setDate(newDate.getDate() + (direction === "next" ? 1 : -1));
    } else if (view === "week") {
      newDate.setDate(newDate.getDate() + (direction === "next" ? 7 : -7));
    } else if (view === "month") {
      newDate.setMonth(newDate.getMonth() + (direction === "next" ? 1 : -1));
    }
    setSelectedDate(newDate);
  };

  // Formato dinámico de la fecha
  const formattedDate = () => {
    if (view === "day") {
      return selectedDate.toLocaleDateString("es-ES", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      });
        } else if (view === "week") {
        const startOfWeek = new Date(selectedDate);

        const day = startOfWeek.getDay(); // Domingo = 0
        const diffToMonday = day === 0 ? -6 : 1 - day;

        startOfWeek.setDate(startOfWeek.getDate() + diffToMonday);
        startOfWeek.setHours(0, 0, 0, 0);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);

        return `${startOfWeek.toLocaleDateString("es-ES", {
          day: "numeric",
          month: "long",
        })} - ${endOfWeek.toLocaleDateString("es-ES", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}`;
      } else if (view === "month") {
      return selectedDate.toLocaleDateString("es-ES", {
        month: "long",
        year: "numeric",
      });
    }
  };

  return (
    <div className="header-controls">
      {/* Botón Hoy */}
      <button className="today-button" onClick={handleTodayClick}>
        Hoy
      </button>

      {/* Flechas de Navegación */}
      <div className="navigation-controls">
        <button
          className="nav-button prev"
          onClick={() => handleNavigate("prev")}
        >
          {"<"}
        </button>
        <span className="current-date">{formattedDate()}</span>
        <button
          className="nav-button next"
          onClick={() => handleNavigate("next")}
        >
          {">"}
        </button>
      </div>
    </div>
  );
};

export default HeaderControls;
